import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    fontFamily: "sans-serif",
  },
  tableHeader: {
    display: "flex",
    flexDirection: "row",
    gap: 30,
    padding: "1rem",
    backgroundColor: "#1c1c22",
    color: "#fff",
    textAlign: "center",
    "@media (max-width: 780px)": {
      gap: 40,
      padding: "10px 0px",
    },
  },
  tableFirstColumnHeader: {
    width: "40%",
    paddingLeft: "20px",
    color: "#fff",
  },
  tableSecondColumnHeader: {
    width: "20%",
    color: "#fff",
  },
  tableThirdColumnHeader: {
    textAlign: "center",
    color: "#fff",
  },
  tableContentContainer: {
    display: "flex",
    flexDirection: "row",
    padding: "1rem",
    borderTop: "1px solid #23232a",
  },
  tableFirstColumn: {
    paddingLeft: 20,
    color: "#ddd",
    fontWeight: 600,
    fontSize: ".85rem",
  },
  includeSection: {
    textAlign: "left",
    width: 10,
    paddingLeft: 0,
    fontSize: "1.5rem",
    "@media (max-width: 960px)": {
      fontSize: "1rem",
    },
  },
  tableSecondColumnTrue: {
    color: "#08D070",
  },
  tableSecondColumnFalse: {
    color: "#d4163c",
  },
  tableThirdColumn: {
    textAlign: "center",
    fontWeight: 400,
    fontSize: ".85rem",
    color: "#ddd",
    "@media (max-width: 960px)": {
      textAlign: "right",
      paddingRight: 20,
    },
  },
}));

export { useStyles };
